(() => {
  const storageKey = 'foria_age_verified_v1';
  const gate = document.querySelector('[data-foria-age-gate]');

  if (!gate || document.documentElement.classList.contains('shopify-design-mode')) return;

  let isVerified = false;
  try {
    isVerified = window.localStorage.getItem(storageKey) === 'true';
  } catch (_error) {
    isVerified = false;
  }

  if (isVerified) return;

  const confirmButton = gate.querySelector('[data-foria-age-confirm]');
  const rejectButton = gate.querySelector('[data-foria-age-reject]');
  const actions = gate.querySelector('[data-foria-age-actions]');
  const rejectedMessage = gate.querySelector('[data-foria-age-rejected]');

  const openGate = () => {
    gate.hidden = false;
    document.body.classList.add('foria-age-gate-open');
    window.requestAnimationFrame(() => confirmButton?.focus());
  };

  const closeGate = () => {
    gate.hidden = true;
    document.body.classList.remove('foria-age-gate-open');
  };

  confirmButton?.addEventListener('click', () => {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (_error) {
      // The confirmation still applies to the current page if storage is unavailable.
    }
    closeGate();
  });

  rejectButton?.addEventListener('click', () => {
    if (actions) actions.hidden = true;
    if (rejectedMessage) rejectedMessage.hidden = false;
    gate.querySelector('.foria-age-gate__panel')?.focus();
  });

  gate.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const focusable = [...gate.querySelectorAll('button:not([hidden])')].filter((element) => !element.disabled);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  openGate();
})();
